import React, { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, Tabs, Tab, Paper, TextField, Select, MenuItem, FormControl, InputLabel, Switch, Checkbox, FormControlLabel, Radio, RadioGroup, LinearProgress, Divider, InputAdornment } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
interface Corridor {
  id: string;
  name: string;
  from: string;
  to: string;
  status: 'Active' | 'Testing' | 'Setup' | 'Inactive';
  paymentTypes: string[];
  partners: number;
  configPercent: number;
  goLiveDate: string;
}
const MOCK_CORRIDORS: Corridor[] = [{
  id: 'GHA-to-GBR',
  name: 'Ghana-UK Corridor',
  from: 'Ghana 🇬🇭',
  to: 'UK 🇬🇧',
  status: 'Active',
  paymentTypes: ['P2P', 'B2B', 'B2C'],
  partners: 5,
  configPercent: 100,
  goLiveDate: '2024-06-15'
}, {
  id: 'NGA-to-USA',
  name: 'Nigeria-US Corridor',
  from: 'Nigeria 🇳🇬',
  to: 'USA 🇺🇸',
  status: 'Active',
  paymentTypes: ['P2P', 'B2B'],
  partners: 3,
  configPercent: 100,
  goLiveDate: '2024-07-20'
}, {
  id: 'GHA-to-DEU',
  name: 'Ghana-Germany Corridor',
  from: 'Ghana 🇬🇭',
  to: 'Germany 🇩🇪',
  status: 'Testing',
  paymentTypes: ['P2P'],
  partners: 2,
  configPercent: 75,
  goLiveDate: '2025-01-15'
}, {
  id: 'SEN-to-FRA',
  name: 'Senegal-France Corridor',
  from: 'Senegal 🇸🇳',
  to: 'France 🇫🇷',
  status: 'Setup',
  paymentTypes: [],
  partners: 0,
  configPercent: 0,
  goLiveDate: 'TBD'
}, {
  id: 'NGA-to-GBR',
  name: 'Nigeria-UK Corridor',
  from: 'Nigeria 🇳🇬',
  to: 'UK 🇬🇧',
  status: 'Active',
  paymentTypes: ['P2P', 'B2B', 'B2C'],
  partners: 6,
  configPercent: 100,
  goLiveDate: '2023-11-10'
}, {
  id: 'CIV-to-FRA',
  name: "Cote d'Ivoire-France Corridor",
  from: "Cote d'Ivoire 🇨🇮",
  to: 'France 🇫🇷',
  status: 'Testing',
  paymentTypes: ['P2P', 'B2C'],
  partners: 1,
  configPercent: 60,
  goLiveDate: '2025-02-28'
}];
export default function CorridorGovernance({
  onLogout
}: {
  onLogout: () => void;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCorridorId, setSelectedCorridorId] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const selectedCorridor = MOCK_CORRIDORS.find(c => c.id === selectedCorridorId);
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Active':
        return '#0B7923';
      case 'Testing':
        return '#B38600';
      case 'Setup':
      case 'Inactive':
        return '#6B7280';
      default:
        return '#6B7280';
    }
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Active':
        return '🟢';
      case 'Testing':
        return '🟡';
      case 'Setup':
      case 'Inactive':
        return '🔴';
      default:
        return '⚪';
    }
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    bgcolor: '#F8F9FA'
  }} data-id="element-2972">
      <TopBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} onLogout={onLogout} data-id="element-2973" />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} activePage="corridor-governance" data-id="element-2974" />

      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8,
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100vh - 64px)',
      overflow: 'hidden'
    }} data-id="element-2975">
        <Container maxWidth="xl" sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        pb: 2
      }} data-id="element-2976">
          {/* TOP SECTION - CORRIDOR OVERVIEW */}
          {!selectedCorridorId && <Box sx={{
          mb: 3
        }} data-id="element-2977">
              <Grid container spacing={2} data-id="element-2978">
                <Grid item xs={12} md={4} data-id="element-2979">
                  <Card elevation={0} sx={{
                bgcolor: '#F3F5F7',
                border: '1px solid #E5E7EB',
                borderRadius: 2
              }} data-id="element-2980">
                    <CardContent sx={{
                  p: 2.5,
                  '&:last-child': {
                    pb: 2.5
                  }
                }} data-id="element-2981">
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-2982">
                        <Typography sx={{
                      fontSize: '24px',
                      mr: 1
                    }} data-id="element-2983">
                          🌍
                        </Typography>
                        <Typography variant="caption" color="#6B7280" fontWeight={600} data-id="element-2984">
                          Active Corridors
                        </Typography>
                      </Box>
                      <Typography variant="h4" fontWeight={700} color="#1F2937" sx={{
                    mb: 0.5
                  }} data-id="element-2985">
                        32
                      </Typography>
                      <Typography variant="caption" fontWeight={600} color="#0B7923" data-id="element-2986">
                        ↑ +3 this month
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} data-id="element-2987">
                  <Card elevation={0} sx={{
                bgcolor: '#F3F5F7',
                border: '1px solid #E5E7EB',
                borderRadius: 2
              }} data-id="element-2988">
                    <CardContent sx={{
                  p: 2.5,
                  '&:last-child': {
                    pb: 2.5
                  }
                }} data-id="element-2989">
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-2990">
                        <Typography sx={{
                      fontSize: '24px',
                      mr: 1
                    }} data-id="element-2991">
                          ⏳
                        </Typography>
                        <Typography variant="caption" color="#6B7280" fontWeight={600} data-id="element-2992">
                          Pending Setup
                        </Typography>
                      </Box>
                      <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                  }} data-id="element-2993">
                        <Typography variant="h4" fontWeight={700} color="#B38600" data-id="element-2994">
                          5
                        </Typography>
                        <Typography variant="caption" fontWeight={600} color="#0052CC" sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }} data-id="element-2995">
                          Review &gt;
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} data-id="element-2996">
                  <Card elevation={0} sx={{
                bgcolor: '#F3F5F7',
                border: '1px solid #E5E7EB',
                borderRadius: 2
              }} data-id="element-2997">
                    <CardContent sx={{
                  p: 2.5,
                  '&:last-child': {
                    pb: 2.5
                  }
                }} data-id="element-2998">
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-2999">
                        <Typography sx={{
                      fontSize: '24px',
                      mr: 1
                    }} data-id="element-3000">
                          🗺️
                        </Typography>
                        <Typography variant="caption" color="#6B7280" fontWeight={600} data-id="element-3001">
                          Countries Covered
                        </Typography>
                      </Box>
                      <Typography variant="h4" fontWeight={700} color="#1F2937" sx={{
                    mb: 0.5
                  }} data-id="element-3002">
                        33
                      </Typography>
                      <Typography variant="caption" color="#6B7280" data-id="element-3003">
                        All Ecobank markets
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <Box sx={{
            mt: 3,
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            alignItems: 'center'
          }} data-id="element-3004">
                <Box sx={{
              display: 'flex',
              gap: 1
            }} data-id="element-3005">
                  <Button variant="contained" size="small" sx={{
                bgcolor: '#0052CC',
                '&:hover': {
                  bgcolor: '#003DA8'
                }
              }} data-id="element-3006">
                    All Corridors
                  </Button>
                  <Button variant="outlined" size="small" sx={{
                color: '#374151',
                borderColor: '#D1D5DB',
                bgcolor: '#FFFFFF'
              }} data-id="element-3007">
                    Active
                  </Button>
                  <Button variant="outlined" size="small" sx={{
                color: '#374151',
                borderColor: '#D1D5DB',
                bgcolor: '#FFFFFF'
              }} data-id="element-3008">
                    Testing
                  </Button>
                  <Button variant="outlined" size="small" sx={{
                color: '#374151',
                borderColor: '#D1D5DB',
                bgcolor: '#FFFFFF'
              }} data-id="element-3009">
                    Setup
                  </Button>
                  <Button variant="outlined" size="small" sx={{
                color: '#374151',
                borderColor: '#D1D5DB',
                bgcolor: '#FFFFFF'
              }} data-id="element-3010">
                    Inactive
                  </Button>
                </Box>
                <Divider orientation="vertical" flexItem sx={{
              height: 24
            }} data-id="element-3011" />
                <FormControl size="small" sx={{
              minWidth: 150,
              bgcolor: '#FFFFFF'
            }} data-id="element-3012">
                  <InputLabel sx={{
                fontSize: '12px'
              }} data-id="element-3013">
                    Payment Types
                  </InputLabel>
                  <Select label="Payment Types" sx={{
                fontSize: '12px'
              }} defaultValue="all" data-id="element-3014">
                    <MenuItem value="all" data-id="element-3015">All</MenuItem>
                    <MenuItem value="p2p" data-id="element-3016">P2P</MenuItem>
                    <MenuItem value="b2b" data-id="element-3017">B2B</MenuItem>
                    <MenuItem value="b2c" data-id="element-3018">B2C</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{
              flexGrow: 1
            }} data-id="element-3019" />
                <TextField size="small" placeholder="Search by route name or countries" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} sx={{
              bgcolor: '#FFFFFF',
              width: 300
            }} InputProps={{
              startAdornment: <InputAdornment position="start" data-id="element-3021">
                        <Icon icon="lucide:search" width={18} color="#6B7280" data-id="element-3022" />
                      </InputAdornment>
            }} data-id="element-3020" />
              </Box>
            </Box>}

          {/* SPLIT PANEL LAYOUT */}
          <Box sx={{
          display: 'flex',
          gap: 3,
          flexGrow: 1,
          overflow: 'hidden'
        }} data-id="element-3023">
            {/* LEFT PANEL - MASTER LIST */}
            <Box sx={{
            width: selectedCorridorId ? '40%' : '100%',
            display: 'flex',
            flexDirection: 'column',
            transition: 'width 0.3s ease',
            bgcolor: '#FFFFFF',
            borderRadius: '8px',
            border: '1px solid #E5E7EB',
            overflow: 'hidden'
          }} data-id="element-3024">
              <Box sx={{
              p: 2,
              borderBottom: '1px solid #E5E7EB',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }} data-id="element-3025">
                <Typography variant="h6" fontWeight={700} color="#1F2937" data-id="element-3026">
                  Corridor Master List
                </Typography>
                {selectedCorridorId && <Button size="small" onClick={() => setSelectedCorridorId(null)} sx={{
                color: '#6B7280'
              }} data-id="element-3027">
                    Close Details
                  </Button>}
              </Box>

              <TableContainer sx={{
              flexGrow: 1,
              overflow: 'auto'
            }} data-id="element-3028">
                <Table stickyHeader size="small" data-id="element-3029">
                  <TableHead data-id="element-3030">
                    <TableRow data-id="element-3031">
                      <TableCell sx={{
                      bgcolor: '#F3F5F7',
                      color: '#0052CC',
                      fontWeight: 700
                    }} data-id="element-3032">
                        Route Name
                      </TableCell>
                      <TableCell sx={{
                      bgcolor: '#F3F5F7',
                      color: '#0052CC',
                      fontWeight: 700
                    }} data-id="element-3033">
                        From → To
                      </TableCell>
                      <TableCell sx={{
                      bgcolor: '#F3F5F7',
                      color: '#0052CC',
                      fontWeight: 700
                    }} data-id="element-3034">
                        Status
                      </TableCell>
                      {!selectedCorridorId && <>
                          <TableCell sx={{
                        bgcolor: '#F3F5F7',
                        color: '#0052CC',
                        fontWeight: 700
                      }} data-id="element-3035">
                            Payment Types
                          </TableCell>
                          <TableCell sx={{
                        bgcolor: '#F3F5F7',
                        color: '#0052CC',
                        fontWeight: 700
                      }} data-id="element-3036">
                            Partners
                          </TableCell>
                          <TableCell sx={{
                        bgcolor: '#F3F5F7',
                        color: '#0052CC',
                        fontWeight: 700
                      }} data-id="element-3037">
                            Config %
                          </TableCell>
                          <TableCell sx={{
                        bgcolor: '#F3F5F7',
                        color: '#0052CC',
                        fontWeight: 700
                      }} data-id="element-3038">
                            Go-Live Date
                          </TableCell>
                          <TableCell sx={{
                        bgcolor: '#F3F5F7',
                        color: '#0052CC',
                        fontWeight: 700
                      }} align="right" data-id="element-3039">
                            Actions
                          </TableCell>
                        </>}
                    </TableRow>
                  </TableHead>
                  <TableBody data-id="element-3040">
                    {MOCK_CORRIDORS.map(row => <TableRow key={row.id} hover onClick={() => setSelectedCorridorId(row.id)} selected={selectedCorridorId === row.id} sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      bgcolor: '#F9FAFB',
                      boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
                    },
                    '&.Mui-selected': {
                      bgcolor: '#F0F3F7'
                    },
                    '&.Mui-selected:hover': {
                      bgcolor: '#F0F3F7'
                    },
                    '& td': {
                      borderBottom: '1px solid #E5E7EB'
                    }
                  }} data-id="element-3041">
                        <TableCell sx={{
                      borderLeft: `3px solid ${getStatusColor(row.status)}`,
                      fontWeight: 600,
                      color: '#1F2937'
                    }} data-id="element-3042">
                          {row.name}
                        </TableCell>
                        <TableCell sx={{
                      fontSize: '13px'
                    }} data-id="element-3043">
                          {row.from} → {row.to}
                        </TableCell>
                        <TableCell data-id="element-3044">
                          <Chip label={`${getStatusIcon(row.status)} ${row.status}`} size="small" sx={{
                        bgcolor: row.status === 'Active' ? 'rgba(11, 121, 35, 0.1)' : row.status === 'Testing' ? 'rgba(179, 134, 0, 0.1)' : '#F3F5F7',
                        color: getStatusColor(row.status),
                        fontWeight: 600,
                        fontSize: '11px',
                        height: 22,
                        border: row.status === 'Setup' ? '1px solid #D1D5DB' : 'none'
                      }} data-id="element-3045" />
                        </TableCell>
                        {!selectedCorridorId && <>
                            <TableCell data-id="element-3046">
                              <Box sx={{
                          display: 'flex',
                          gap: 0.5
                        }} data-id="element-3047">
                                {row.paymentTypes.length > 0 ? row.paymentTypes.map(pt => <Chip key={pt} label={pt} size="small" sx={{
                            height: 18,
                            fontSize: '10px',
                            bgcolor: '#F3F5F7',
                            border: '1px solid #E5E7EB'
                          }} data-id="element-3048" />) : <Typography variant="caption" color="#6B7280" data-id="element-3049">
                                    None yet
                                  </Typography>}
                              </Box>
                            </TableCell>
                            <TableCell sx={{
                        color: '#0052CC',
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }} data-id="element-3050">
                              {row.partners} partners
                            </TableCell>
                            <TableCell data-id="element-3051">
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3052">
                                <Box sx={{
                            width: 60,
                            height: 6,
                            bgcolor: '#E5E7EB',
                            borderRadius: 3,
                            overflow: 'hidden'
                          }} data-id="element-3053">
                                  <Box sx={{
                              width: `${row.configPercent}%`,
                              height: '100%',
                              bgcolor: getStatusColor(row.status)
                            }} data-id="element-3054" />
                                </Box>
                                <Typography variant="caption" color="#6B7280" data-id="element-3055">
                                  {row.configPercent}%
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{
                        fontSize: '12px',
                        color: '#6B7280'
                      }} data-id="element-3056">
                              {row.goLiveDate}
                            </TableCell>
                            <TableCell align="right" data-id="element-3057">
                              <IconButton size="small" sx={{
                          color: '#6B7280'
                        }} data-id="element-3058">
                                <Icon icon="lucide:more-vertical" width={16} data-id="element-3059" />
                              </IconButton>
                            </TableCell>
                          </>}
                      </TableRow>)}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{
              p: 1.5,
              borderTop: '1px solid #E5E7EB',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }} data-id="element-3060">
                <Typography variant="caption" color="#6B7280" data-id="element-3061">
                  Showing 1-{MOCK_CORRIDORS.length} of 37 corridors
                </Typography>
                <Box sx={{
                display: 'flex',
                gap: 1
              }} data-id="element-3062">
                  <Button size="small" disabled sx={{
                  fontSize: '11px'
                }} data-id="element-3063">
                    &lt; Previous
                  </Button>
                  <Button size="small" disabled sx={{
                  fontSize: '11px'
                }} data-id="element-3064">
                    Next &gt;
                  </Button>
                </Box>
              </Box>
            </Box>

            {/* RIGHT PANEL - DETAIL CONFIGURATION */}
            {selectedCorridor && <Box sx={{
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#FFFFFF',
            borderRadius: '8px',
            border: '1px solid #E5E7EB',
            borderLeft: `3px solid ${getStatusColor(selectedCorridor.status)}`,
            overflow: 'hidden'
          }} data-id="element-3065">
                {/* HEADER SECTION */}
                <Box sx={{
              p: 3,
              borderBottom: '1px solid #E5E7EB',
              bgcolor: '#FFFFFF'
            }} data-id="element-3066">
                  <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 1
              }} data-id="element-3067">
                    <Box data-id="element-3068">
                      <Typography variant="h5" fontWeight={700} color="#1F2937" sx={{
                    mb: 0.5
                  }} data-id="element-3069">
                        {selectedCorridor.name}
                      </Typography>
                      <Typography sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px',
                    color: '#6B7280'
                  }} data-id="element-3070">
                        {selectedCorridor.id}
                      </Typography>
                    </Box>
                    <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  gap: 1
                }} data-id="element-3071">
                      <Chip label={`${getStatusIcon(selectedCorridor.status)} ${selectedCorridor.status}`} size="small" sx={{
                    bgcolor: selectedCorridor.status === 'Active' ? 'rgba(11, 121, 35, 0.1)' : selectedCorridor.status === 'Testing' ? 'rgba(179, 134, 0, 0.1)' : '#F3F5F7',
                    color: getStatusColor(selectedCorridor.status),
                    fontWeight: 700
                  }} data-id="element-3072" />
                      <Typography variant="caption" color="#6B7280" data-id="element-3073">
                        Go-Live: {selectedCorridor.goLiveDate}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* TABS */}
                <Box sx={{
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: '#FFFFFF'
            }} data-id="element-3074">
                  <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)} variant="scrollable" scrollButtons="auto" sx={{
                minHeight: 40,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  minHeight: 40,
                  fontWeight: 600,
                  color: '#6B7280',
                  fontSize: '13px',
                  '&.Mui-selected': {
                    color: '#0052CC'
                  }
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#0052CC'
                }
              }} data-id="element-3075">
                    <Tab label="Basic Settings" data-id="element-3076" />
                    <Tab label="Channels" data-id="element-3077" />
                    <Tab label="Routing Rules" data-id="element-3078" />
                    <Tab label="Compliance Rules" data-id="element-3079" />
                    <Tab label="Settlement & FX" data-id="element-3080" />
                    <Tab label="Testing & Cert" data-id="element-3081" />
                  </Tabs>
                </Box>

                {/* TAB CONTENT */}
                <Box sx={{
              flexGrow: 1,
              overflow: 'auto',
              p: 3,
              bgcolor: '#F8F9FA',
              display: 'flex',
              gap: 3
            }} data-id="element-3082">
                  <Box sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 3
              }} data-id="element-3083">
                    {/* TAB 1: BASIC SETTINGS */}
                    {activeTab === 0 && <Card elevation={0} sx={{
                  border: '1px solid #E5E7EB',
                  borderRadius: 2
                }} data-id="element-3084">
                        <CardContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2.5
                  }} data-id="element-3085">
                          <Box data-id="element-3086">
                            <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3087">
                              Corridor Name{' '}
                              <span style={{
                          color: '#AE2A19'
                        }} data-id="element-3088">
                                *
                              </span>
                            </Typography>
                            <TextField fullWidth size="small" defaultValue={selectedCorridor.name} sx={{
                        bgcolor: '#FFFFFF'
                      }} data-id="element-3089" />
                          </Box>

                          <Box data-id="element-3090">
                            <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3091">
                              Route Code (Auto-generated)
                            </Typography>
                            <Typography sx={{
                        fontFamily: 'monospace',
                        fontSize: '14px',
                        color: '#6B7280',
                        p: 1,
                        bgcolor: '#F3F5F7',
                        borderRadius: 1,
                        border: '1px solid #E5E7EB'
                      }} data-id="element-3092">
                              {selectedCorridor.id}
                            </Typography>
                          </Box>

                          <Grid container spacing={2} data-id="element-3093">
                            <Grid item xs={6} data-id="element-3094">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3095">
                                From Country{' '}
                                <span style={{
                            color: '#AE2A19'
                          }} data-id="element-3096">
                                  *
                                </span>
                              </Typography>
                              <FormControl fullWidth size="small" sx={{
                          bgcolor: '#FFFFFF'
                        }} data-id="element-3097">
                                <Select defaultValue="ghana" data-id="element-3098">
                                  <MenuItem value="ghana" data-id="element-3099">Ghana 🇬🇭</MenuItem>
                                  <MenuItem value="nigeria" data-id="element-3100">
                                    Nigeria 🇳🇬
                                  </MenuItem>
                                  <MenuItem value="senegal" data-id="element-3101">
                                    Senegal 🇸🇳
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={6} data-id="element-3102">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3103">
                                To Country{' '}
                                <span style={{
                            color: '#AE2A19'
                          }} data-id="element-3104">
                                  *
                                </span>
                              </Typography>
                              <FormControl fullWidth size="small" sx={{
                          bgcolor: '#FFFFFF'
                        }} data-id="element-3105">
                                <Select defaultValue="uk" data-id="element-3106">
                                  <MenuItem value="uk" data-id="element-3107">
                                    United Kingdom 🇬🇧
                                  </MenuItem>
                                  <MenuItem value="usa" data-id="element-3108">USA 🇺🇸</MenuItem>
                                  <MenuItem value="france" data-id="element-3109">France 🇫🇷</MenuItem>
                                  <MenuItem value="germany" data-id="element-3110">
                                    Germany 🇩🇪
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>

                          <Box data-id="element-3111">
                            <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3112">
                              Description
                            </Typography>
                            <TextField fullWidth multiline rows={3} placeholder="Optional corridor description" size="small" sx={{
                        bgcolor: '#FFFFFF'
                      }} data-id="element-3113" />
                          </Box>

                          <Box data-id="element-3114">
                            <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3115">
                              Status
                            </Typography>
                            <FormControlLabel control={<Switch defaultChecked={selectedCorridor.status === 'Active'} color="success" data-id="element-3117" />} label={<Typography variant="body2" fontWeight={600} data-id="element-3118">
                                  {selectedCorridor.status === 'Active' ? 'Active' : 'Inactive'}
                                </Typography>} data-id="element-3116" />
                          </Box>

                          <Box data-id="element-3119">
                            <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3120">
                              Payment Types Enabled{' '}
                              <span style={{
                          color: '#AE2A19'
                        }} data-id="element-3121">
                                *
                              </span>
                            </Typography>
                            <Grid container spacing={1} data-id="element-3122">
                              <Grid item xs={4} data-id="element-3123">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3125" />} label={<Typography variant="body2" data-id="element-3126">
                                      P2P (Person-to-Person)
                                    </Typography>} data-id="element-3124" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3127">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3129" />} label={<Typography variant="body2" data-id="element-3130">
                                      B2B (Business-to-Business)
                                    </Typography>} data-id="element-3128" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3131">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3133" />} label={<Typography variant="body2" data-id="element-3134">
                                      B2C (Business-to-Consumer)
                                    </Typography>} data-id="element-3132" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3135">
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3137" />} label={<Typography variant="body2" data-id="element-3138">C2B</Typography>} data-id="element-3136" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3139">
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3141" />} label={<Typography variant="body2" data-id="element-3142">A2A</Typography>} data-id="element-3140" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3143">
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3145" />} label={<Typography variant="body2" data-id="element-3146">
                                      Wallet-to-Wallet
                                    </Typography>} data-id="element-3144" />
                              </Grid>
                            </Grid>
                            <Typography variant="caption" color="#0052CC" sx={{
                        cursor: 'pointer',
                        mt: 1,
                        display: 'inline-block'
                      }} data-id="element-3147">
                              Show 5 more...
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>}

                    {/* TAB 2: CHANNELS */}
                    {activeTab === 1 && <Grid container spacing={3} data-id="element-3148">
                        <Grid item xs={6} data-id="element-3149">
                          <Card elevation={0} sx={{
                      border: '1px solid #E5E7EB',
                      borderRadius: 2,
                      height: '100%'
                    }} data-id="element-3150">
                            <CardContent data-id="element-3151">
                              <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3152">
                                How Can Customers Send?
                              </Typography>
                              <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1
                        }} data-id="element-3153">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3155" />} label={<Typography variant="body2" data-id="element-3156">
                                      Bank Account
                                    </Typography>} data-id="element-3154" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3158" />} label={<Typography variant="body2" data-id="element-3159">
                                      Mobile Wallet
                                    </Typography>} data-id="element-3157" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3161" />} label={<Typography variant="body2" data-id="element-3162">
                                      Payment Card
                                    </Typography>} data-id="element-3160" />
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3164" />} label={<Typography variant="body2" data-id="element-3165">
                                      Cash-in Agent
                                    </Typography>} data-id="element-3163" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3167" />} label={<Typography variant="body2" data-id="element-3168">API</Typography>} data-id="element-3166" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3170" />} label={<Typography variant="body2" data-id="element-3171">
                                      ISO 20022 Batch
                                    </Typography>} data-id="element-3169" />
                              </Box>
                              <Box sx={{
                          mt: 3,
                          p: 1.5,
                          bgcolor: '#ECFDF5',
                          borderRadius: 1,
                          border: '1px solid #0B7923',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3172">
                                <Icon icon="lucide:check-circle" color="#0B7923" width={16} data-id="element-3173" />
                                <Typography variant="caption" color="#0B7923" fontWeight={600} data-id="element-3174">
                                  All channels tested and active
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                        <Grid item xs={6} data-id="element-3175">
                          <Card elevation={0} sx={{
                      border: '1px solid #E5E7EB',
                      borderRadius: 2,
                      height: '100%'
                    }} data-id="element-3176">
                            <CardContent data-id="element-3177">
                              <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3178">
                                How Can Customers Receive?
                              </Typography>
                              <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1
                        }} data-id="element-3179">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3181" />} label={<Typography variant="body2" data-id="element-3182">
                                      Bank Account
                                    </Typography>} data-id="element-3180" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3184" />} label={<Typography variant="body2" data-id="element-3185">
                                      Mobile Wallet
                                    </Typography>} data-id="element-3183" />
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3187" />} label={<Typography variant="body2" data-id="element-3188">
                                      Payment Card
                                    </Typography>} data-id="element-3186" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3190" />} label={<Typography variant="body2" data-id="element-3191">
                                      Cash-out (Ecobank branches)
                                    </Typography>} data-id="element-3189" />
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3193" />} label={<Typography variant="body2" data-id="element-3194">
                                      Vouchers
                                    </Typography>} data-id="element-3192" />
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3196" />} label={<Typography variant="body2" data-id="element-3197">
                                      Corporate Settlement Account
                                    </Typography>} data-id="element-3195" />
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>}

                    {/* TAB 3: ROUTING RULES */}
                    {activeTab === 2 && <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3
                }} data-id="element-3198">
                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3199">
                          <CardContent sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2.5
                    }} data-id="element-3200">
                            <Grid container spacing={3} data-id="element-3201">
                              <Grid item xs={4} data-id="element-3202">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3203">
                                  Primary Route
                                </Typography>
                                <FormControl fullWidth size="small" sx={{
                            bgcolor: '#FFFFFF',
                            mb: 0.5
                          }} data-id="element-3204">
                                  <Select defaultValue="bank" data-id="element-3205">
                                    <MenuItem value="bank" data-id="element-3206">
                                      Bank Account
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                                <Typography variant="caption" color="#6B7280" data-id="element-3207">
                                  This is the preferred route for normal
                                  transactions
                                </Typography>
                              </Grid>
                              <Grid item xs={4} data-id="element-3208">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3209">
                                  Secondary Route (Fallback 1)
                                </Typography>
                                <FormControl fullWidth size="small" sx={{
                            bgcolor: '#FFFFFF',
                            mb: 0.5
                          }} data-id="element-3210">
                                  <Select defaultValue="wallet" data-id="element-3211">
                                    <MenuItem value="wallet" data-id="element-3212">
                                      Mobile Wallet
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                                <Typography variant="caption" color="#6B7280" data-id="element-3213">
                                  Automatically try this if primary fails
                                </Typography>
                              </Grid>
                              <Grid item xs={4} data-id="element-3214">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3215">
                                  Tertiary Route (Fallback 2)
                                </Typography>
                                <FormControl fullWidth size="small" sx={{
                            bgcolor: '#FFFFFF',
                            mb: 0.5
                          }} data-id="element-3216">
                                  <Select defaultValue="cash" data-id="element-3217">
                                    <MenuItem value="cash" data-id="element-3218">Cash Out</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>

                            <Box sx={{
                        bgcolor: '#F3F5F7',
                        p: 2,
                        borderRadius: 2,
                        border: '1px solid #E5E7EB'
                      }} data-id="element-3219">
                              <Typography variant="caption" fontWeight={700} color="#1F2937" display="block" mb={1.5} data-id="element-3220">
                                Routing Decision Tree
                              </Typography>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          justifyContent: 'center',
                          py: 2
                        }} data-id="element-3221">
                                <Chip label="Start" sx={{
                            bgcolor: '#1F2937',
                            color: 'white'
                          }} data-id="element-3222" />
                                <Icon icon="lucide:arrow-right" color="#6B7280" data-id="element-3223" />
                                <Chip label="Bank Account" sx={{
                            bgcolor: '#0052CC',
                            color: 'white'
                          }} data-id="element-3224" />
                                <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }} data-id="element-3225">
                                  <Typography variant="caption" color="#AE2A19" fontSize="10px" data-id="element-3226">
                                    If Failed
                                  </Typography>
                                  <Icon icon="lucide:arrow-right" color="#6B7280" data-id="element-3227" />
                                </Box>
                                <Chip label="Mobile Wallet" sx={{
                            bgcolor: '#B38600',
                            color: 'white'
                          }} data-id="element-3228" />
                                <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }} data-id="element-3229">
                                  <Typography variant="caption" color="#AE2A19" fontSize="10px" data-id="element-3230">
                                    If Failed
                                  </Typography>
                                  <Icon icon="lucide:arrow-right" color="#6B7280" data-id="element-3231" />
                                </Box>
                                <Chip label="Cash Out" sx={{
                            bgcolor: '#6B7280',
                            color: 'white'
                          }} data-id="element-3232" />
                              </Box>
                            </Box>

                            <TableContainer component={Paper} elevation={0} sx={{
                        border: '1px solid #E5E7EB'
                      }} data-id="element-3233">
                              <Table size="small" data-id="element-3234">
                                <TableHead data-id="element-3235">
                                  <TableRow sx={{
                              bgcolor: '#F3F5F7'
                            }} data-id="element-3236">
                                    <TableCell sx={{
                                fontWeight: 600,
                                color: '#374151'
                              }} data-id="element-3237">
                                      Route
                                    </TableCell>
                                    <TableCell sx={{
                                fontWeight: 600,
                                color: '#374151'
                              }} data-id="element-3238">
                                      Cost per Tx
                                    </TableCell>
                                    <TableCell sx={{
                                fontWeight: 600,
                                color: '#374151'
                              }} data-id="element-3239">
                                      Speed
                                    </TableCell>
                                    <TableCell sx={{
                                fontWeight: 600,
                                color: '#374151'
                              }} data-id="element-3240">
                                      Recommended For
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody data-id="element-3241">
                                  <TableRow data-id="element-3242">
                                    <TableCell data-id="element-3243">Bank Account</TableCell>
                                    <TableCell data-id="element-3244">$2.50</TableCell>
                                    <TableCell data-id="element-3245">2-3 hours</TableCell>
                                    <TableCell data-id="element-3246">Retail transfers</TableCell>
                                  </TableRow>
                                  <TableRow data-id="element-3247">
                                    <TableCell data-id="element-3248">Mobile Wallet</TableCell>
                                    <TableCell data-id="element-3249">$1.75</TableCell>
                                    <TableCell data-id="element-3250">5-10 min</TableCell>
                                    <TableCell data-id="element-3251">Speed-sensitive</TableCell>
                                  </TableRow>
                                  <TableRow data-id="element-3252">
                                    <TableCell data-id="element-3253">Cash Out</TableCell>
                                    <TableCell data-id="element-3254">$1.50</TableCell>
                                    <TableCell data-id="element-3255">Real-time</TableCell>
                                    <TableCell data-id="element-3256">Urgent payouts</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <Box data-id="element-3257">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={1} data-id="element-3258">
                                Routing Priority
                              </Typography>
                              <RadioGroup row defaultValue="partner" data-id="element-3259">
                                <FormControlLabel value="cost" control={<Radio size="small" data-id="element-3261" />} label={<Typography variant="body2" data-id="element-3262">
                                      Cost-Optimized
                                    </Typography>} data-id="element-3260" />
                                <FormControlLabel value="speed" control={<Radio size="small" data-id="element-3264" />} label={<Typography variant="body2" data-id="element-3265">
                                      Speed-Optimized
                                    </Typography>} data-id="element-3263" />
                                <FormControlLabel value="partner" control={<Radio size="small" data-id="element-3267" />} label={<Typography variant="body2" data-id="element-3268">
                                      Partner Preference
                                    </Typography>} data-id="element-3266" />
                                <FormControlLabel value="custom" control={<Radio size="small" data-id="element-3270" />} label={<Typography variant="body2" data-id="element-3271">
                                      Custom Rule
                                    </Typography>} data-id="element-3269" />
                              </RadioGroup>
                            </Box>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3272">
                          <CardContent data-id="element-3273">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3274">
                              Compliance Controls
                            </Typography>
                            <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1
                      }} data-id="element-3275">
                              <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3277" />} label={<Typography variant="body2" data-id="element-3278">
                                    Auto-block if high-risk corridor
                                  </Typography>} data-id="element-3276" />
                              <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3280" />} label={<Typography variant="body2" data-id="element-3281">
                                    Use fallback route if primary fails
                                    compliance
                                  </Typography>} data-id="element-3279" />
                              <FormControlLabel control={<Checkbox size="small" data-id="element-3283" />} label={<Typography variant="body2" data-id="element-3284">
                                    Disable payout if any risk present (strict
                                    mode)
                                  </Typography>} data-id="element-3282" />
                            </Box>
                          </CardContent>
                        </Card>
                      </Box>}

                    {/* TAB 4: COMPLIANCE RULES */}
                    {activeTab === 3 && <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3
                }} data-id="element-3285">
                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3286">
                          <CardContent data-id="element-3287">
                            <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        mb: 1
                      }} data-id="element-3288">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" data-id="element-3289">
                                High-Risk Corridor
                              </Typography>
                              <Switch color="error" data-id="element-3290" />
                            </Box>
                            <Typography variant="caption" color="#AE2A19" fontWeight={600} data-id="element-3291">
                              All transactions flagged for compliance review
                            </Typography>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3292">
                          <CardContent data-id="element-3293">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3294">
                              Transaction Limits by Corridor
                            </Typography>
                            <Grid container spacing={3} data-id="element-3295">
                              <Grid item xs={4} data-id="element-3296">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3297">
                                  Daily Limit
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="$ 100,000" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3298" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3299">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3300">
                                  Per-Transaction Maximum
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="$ 10,000" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3301" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3302">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3303">
                                  Monthly Limit
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="$ 2,000,000" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3304" />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3305">
                          <CardContent data-id="element-3306">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3307">
                              Velocity & Frequency Controls
                            </Typography>
                            <Grid container spacing={3} data-id="element-3308">
                              <Grid item xs={4} data-id="element-3309">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3310">
                                  Max Transactions Per Hour
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="100" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3311" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3312">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3313">
                                  Max Transactions Per Day
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="500" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3314" />
                              </Grid>
                              <Grid item xs={4} data-id="element-3315">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3316">
                                  Max Amount Per Day (per beneficiary)
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="$ 50,000" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3317" />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3318">
                          <CardContent data-id="element-3319">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3320">
                              Corridor-Specific AML Rules
                            </Typography>
                            <TextField fullWidth multiline rows={3} placeholder="Enter countries/scenarios that auto-flag for review" size="small" sx={{
                        bgcolor: '#FFFFFF'
                      }} data-id="element-3321" />
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3322">
                          <CardContent data-id="element-3323">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3324">
                              Geographic Restrictions (Optional)
                            </Typography>
                            <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1
                      }} data-id="element-3325">
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2
                        }} data-id="element-3326">
                                <FormControlLabel control={<Checkbox defaultChecked size="small" data-id="element-3328" />} label={<Typography variant="body2" data-id="element-3329">
                                      Restrict sending only from:
                                    </Typography>} data-id="element-3327" />
                                <FormControl size="small" sx={{
                            minWidth: 150,
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3330">
                                  <Select defaultValue="ghana" data-id="element-3331">
                                    <MenuItem value="ghana" data-id="element-3332">Ghana</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2
                        }} data-id="element-3333">
                                <FormControlLabel control={<Checkbox size="small" data-id="element-3335" />} label={<Typography variant="body2" data-id="element-3336">
                                      Restrict receiving only from:
                                    </Typography>} data-id="element-3334" />
                                <FormControl size="small" sx={{
                            minWidth: 150,
                            bgcolor: '#FFFFFF'
                          }} disabled data-id="element-3337">
                                  <Select defaultValue="uk" data-id="element-3338">
                                    <MenuItem value="uk" data-id="element-3339">UK</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </Box>}

                    {/* TAB 5: SETTLEMENT & FX */}
                    {activeTab === 4 && <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3
                }} data-id="element-3340">
                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3341">
                          <CardContent sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2.5
                    }} data-id="element-3342">
                            <Box data-id="element-3343">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3344">
                                Settlement Frequency{' '}
                                <span style={{
                            color: '#AE2A19'
                          }} data-id="element-3345">
                                  *
                                </span>
                              </Typography>
                              <FormControl fullWidth size="small" sx={{
                          bgcolor: '#FFFFFF',
                          mb: 0.5
                        }} data-id="element-3346">
                                <Select defaultValue="daily" data-id="element-3347">
                                  <MenuItem value="daily" data-id="element-3348">Daily</MenuItem>
                                </Select>
                              </FormControl>
                              <Typography variant="caption" color="#6B7280" data-id="element-3349">
                                Transactions will be settled daily at 23:59 UTC
                              </Typography>
                            </Box>

                            <Box data-id="element-3350">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3351">
                                Net Settlement
                              </Typography>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3352">
                                <Switch defaultChecked color="primary" data-id="element-3353" />
                                <Typography variant="body2" fontWeight={600} data-id="element-3354">
                                  Enabled
                                </Typography>
                              </Box>
                              <Typography variant="caption" color="#6B7280" data-id="element-3355">
                                Enable bilateral netting (send vs receive flows
                                offset)
                              </Typography>
                            </Box>

                            <Box data-id="element-3356">
                              <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3357">
                                Settlement Account{' '}
                                <span style={{
                            color: '#AE2A19'
                          }} data-id="element-3358">
                                  *
                                </span>
                              </Typography>
                              <FormControl fullWidth size="small" sx={{
                          bgcolor: '#FFFFFF'
                        }} data-id="element-3359">
                                <Select defaultValue="acct1" data-id="element-3360">
                                  <MenuItem value="acct1" data-id="element-3361">
                                    1130-GHA-GBR-Settlement
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3362">
                          <CardContent data-id="element-3363">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3364">
                              FX & Multi-Currency Setup
                            </Typography>
                            <Grid container spacing={3} data-id="element-3365">
                              <Grid item xs={4} data-id="element-3366">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3367">
                                  Funding Currency
                                </Typography>
                                <FormControl fullWidth size="small" sx={{
                            bgcolor: '#F3F5F7'
                          }} disabled data-id="element-3368">
                                  <Select defaultValue="usd" data-id="element-3369">
                                    <MenuItem value="usd" data-id="element-3370">USD</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4} data-id="element-3371">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3372">
                                  Payout Currency
                                </Typography>
                                <FormControl fullWidth size="small" sx={{
                            bgcolor: '#FFFFFF'
                          }} data-id="element-3373">
                                  <Select defaultValue="gbp" data-id="element-3374">
                                    <MenuItem value="gbp" data-id="element-3375">GBP</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4} data-id="element-3376">
                                <Typography variant="caption" fontWeight={700} color="#6B7280" display="block" mb={0.5} data-id="element-3377">
                                  FX Margin for this Corridor
                                </Typography>
                                <TextField fullWidth size="small" defaultValue="2.0" sx={{
                            bgcolor: '#FFFFFF',
                            mb: 0.5
                          }} InputProps={{
                            endAdornment: <InputAdornment position="end" data-id="element-3379">
                                        %
                                      </InputAdornment>
                          }} data-id="element-3378" />
                                <Typography variant="caption" color="#6B7280" data-id="element-3380">
                                  Applied on top of daily fixing rate
                                </Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Box>}

                    {/* TAB 6: TESTING & CERTIFICATION */}
                    {activeTab === 5 && <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3
                }} data-id="element-3381">
                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3382">
                          <CardContent data-id="element-3383">
                            <Button variant="contained" sx={{
                        bgcolor: '#0052CC',
                        '&:hover': {
                          bgcolor: '#003DA8'
                        },
                        mb: 3
                      }} data-id="element-3384">
                              Test Connectivity
                            </Button>
                            <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5
                      }} data-id="element-3385">
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3386">
                                <Icon icon="lucide:check-circle" color="#0B7923" width={16} data-id="element-3387" />
                                <Typography variant="body2" color="#374151" data-id="element-3388">
                                  Bank API Connected{' '}
                                  <span style={{
                              color: '#0B7923'
                            }} data-id="element-3389">
                                    (145ms)
                                  </span>
                                </Typography>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3390">
                                <Icon icon="lucide:check-circle" color="#0B7923" width={16} data-id="element-3391" />
                                <Typography variant="body2" color="#374151" data-id="element-3392">
                                  Mobile Wallet Provider Connected{' '}
                                  <span style={{
                              color: '#0B7923'
                            }} data-id="element-3393">
                                    (120ms)
                                  </span>
                                </Typography>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3394">
                                <Icon icon="lucide:check-circle" color="#0B7923" width={16} data-id="element-3395" />
                                <Typography variant="body2" color="#374151" data-id="element-3396">
                                  Cash Agent Network Connected{' '}
                                  <span style={{
                              color: '#0B7923'
                            }} data-id="element-3397">
                                    (890ms)
                                  </span>
                                </Typography>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }} data-id="element-3398">
                                <Icon icon="lucide:check-circle" color="#0B7923" width={16} data-id="element-3399" />
                                <Typography variant="body2" color="#374151" data-id="element-3400">
                                  All Partner Endpoints Reachable
                                </Typography>
                              </Box>
                              <Typography variant="caption" color="#0B7923" fontWeight={600} sx={{
                          mt: 1
                        }} data-id="element-3401">
                                Status: Connectivity verified. All systems
                                online.
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>

                        <Card elevation={0} sx={{
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-3402">
                          <CardContent data-id="element-3403">
                            <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3404">
                              Corridor Certification
                            </Typography>
                            <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        mb: 3
                      }} data-id="element-3405">
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1
                        }} data-id="element-3406">
                                <Checkbox defaultChecked size="small" sx={{
                            p: 0
                          }} data-id="element-3407" />
                                <Box data-id="element-3408">
                                  <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-3409">
                                    Business requirements defined
                                  </Typography>
                                  <Typography variant="caption" color="#6B7280" data-id="element-3410">
                                    Completed by: Product Team, Date: 2024-06-10
                                  </Typography>
                                </Box>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1
                        }} data-id="element-3411">
                                <Checkbox defaultChecked size="small" sx={{
                            p: 0
                          }} data-id="element-3412" />
                                <Box data-id="element-3413">
                                  <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-3414">
                                    Compliance rules configured
                                  </Typography>
                                  <Typography variant="caption" color="#6B7280" data-id="element-3415">
                                    Reviewed by: Compliance Officer, Date:
                                    2024-06-11
                                  </Typography>
                                </Box>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1
                        }} data-id="element-3416">
                                <Checkbox defaultChecked size="small" sx={{
                            p: 0
                          }} data-id="element-3417" />
                                <Box data-id="element-3418">
                                  <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-3419">
                                    Integration with partners tested
                                  </Typography>
                                  <Typography variant="caption" color="#6B7280" data-id="element-3420">
                                    Certified by: Tech Team, Date: 2024-06-12
                                  </Typography>
                                </Box>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2
                        }} data-id="element-3421">
                                <Checkbox size="small" sx={{
                            p: 0
                          }} data-id="element-3422" />
                                <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-3423">
                                  UAT completed
                                </Typography>
                                <Chip label="NOT STARTED" size="small" sx={{
                            bgcolor: '#FFFBEB',
                            color: '#B38600',
                            height: 20,
                            fontSize: '10px',
                            fontWeight: 700
                          }} data-id="element-3424" />
                                <Button size="small" variant="outlined" sx={{
                            py: 0,
                            fontSize: '11px'
                          }} data-id="element-3425">
                                  Run UAT
                                </Button>
                              </Box>
                              <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2
                        }} data-id="element-3426">
                                <Checkbox size="small" sx={{
                            p: 0
                          }} data-id="element-3427" />
                                <Typography variant="body2" fontWeight={600} color="#1F2937" data-id="element-3428">
                                  Regulatory approval obtained
                                </Typography>
                                <Chip label="NOT STARTED" size="small" sx={{
                            bgcolor: '#FFFBEB',
                            color: '#B38600',
                            height: 20,
                            fontSize: '10px',
                            fontWeight: 700
                          }} data-id="element-3429" />
                                <Button size="small" variant="outlined" sx={{
                            py: 0,
                            fontSize: '11px'
                          }} data-id="element-3430">
                                  Request Approval
                                </Button>
                              </Box>
                            </Box>
                            <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                      }} data-id="element-3431">
                              <Box sx={{
                          flexGrow: 1,
                          height: 8,
                          bgcolor: '#E5E7EB',
                          borderRadius: 4,
                          overflow: 'hidden'
                        }} data-id="element-3432">
                                <Box sx={{
                            width: '75%',
                            height: '100%',
                            bgcolor: '#0B7923'
                          }} data-id="element-3433" />
                              </Box>
                              <Typography variant="caption" fontWeight={700} color="#0B7923" data-id="element-3434">
                                75% Complete
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>

                        <Box sx={{
                    bgcolor: '#FFFBEB',
                    p: 3,
                    borderRadius: 2,
                    border: '1px solid #B38600',
                    textAlign: 'center'
                  }} data-id="element-3435">
                          <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={1} data-id="element-3436">
                            Certification Status
                          </Typography>
                          <Typography variant="h6" fontWeight={700} color="#B38600" mb={1} data-id="element-3437">
                            In Progress
                          </Typography>
                          <Typography variant="body2" color="#374151" data-id="element-3438">
                            Complete remaining items to certify
                          </Typography>
                        </Box>
                      </Box>}
                  </Box>

                  {/* RIGHT SIDEBAR - HELP & TIMELINE */}
                  <Box sx={{
                width: 250,
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 3
              }} data-id="element-3439">
                    <Card elevation={0} sx={{
                  bgcolor: '#F3F5F7',
                  border: '1px solid #E5E7EB',
                  borderRadius: 2
                }} data-id="element-3440">
                      <CardContent data-id="element-3441">
                        <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3442">
                          Configuration Help
                        </Typography>
                        <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5
                    }} data-id="element-3443">
                          <Typography variant="body2" color="#0052CC" sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }} data-id="element-3444">
                            Corridor Setup Guide
                          </Typography>
                          <Typography variant="body2" color="#0052CC" sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }} data-id="element-3445">
                            Configuration Best Practices
                          </Typography>
                          <Typography variant="body2" color="#0052CC" sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }} data-id="element-3446">
                            Payment Types Explained
                          </Typography>
                          <Typography variant="body2" color="#0052CC" sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }} data-id="element-3447">
                            Contact Operations Support
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>

                    <Card elevation={0} sx={{
                  border: '1px solid #E5E7EB',
                  borderRadius: 2
                }} data-id="element-3448">
                      <CardContent data-id="element-3449">
                        <Typography variant="subtitle2" fontWeight={700} color="#1F2937" mb={2} data-id="element-3450">
                          Corridor History
                        </Typography>
                        <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5
                    }} data-id="element-3451">
                          <Box data-id="element-3452">
                            <Typography variant="caption" color="#6B7280" display="block" data-id="element-3453">
                              Created
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-3454">
                              2024-06-01 10:30 AM
                            </Typography>
                          </Box>
                          <Box data-id="element-3455">
                            <Typography variant="caption" color="#6B7280" display="block" data-id="element-3456">
                              Config started
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-3457">
                              2024-06-01 2:00 PM
                            </Typography>
                          </Box>
                          <Box data-id="element-3458">
                            <Typography variant="caption" color="#6B7280" display="block" data-id="element-3459">
                              Compliance certified
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-3460">
                              2024-06-10 3:45 PM
                            </Typography>
                          </Box>
                          <Box data-id="element-3461">
                            <Typography variant="caption" color="#6B7280" display="block" data-id="element-3462">
                              Go-live
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-3463">
                              2024-06-15 9:00 AM
                            </Typography>
                          </Box>
                          <Box data-id="element-3464">
                            <Typography variant="caption" color="#6B7280" display="block" data-id="element-3465">
                              Last configuration change
                            </Typography>
                            <Typography variant="body2" color="#374151" data-id="element-3466">
                              2025-01-01 14:35 UTC by Sarah Johnson (Ecobank
                              Operations)
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                </Box>

                {/* BOTTOM ACTION BUTTONS */}
                <Box sx={{
              p: 2,
              borderTop: '1px solid #E5E7EB',
              bgcolor: '#FFFFFF',
              display: 'flex',
              gap: 1,
              flexWrap: 'wrap'
            }} data-id="element-3467">
                  {selectedCorridor.status === 'Active' && <>
                      <Button variant="contained" sx={{
                  bgcolor: '#0052CC',
                  '&:hover': {
                    bgcolor: '#003DA8'
                  }
                }} data-id="element-3468">
                        Edit
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#374151',
                  borderColor: '#D1D5DB'
                }} data-id="element-3469">
                        View Performance Data
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#B38600',
                  borderColor: '#B38600'
                }} data-id="element-3470">
                        Pause Corridor
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#AE2A19',
                  borderColor: '#AE2A19'
                }} data-id="element-3471">
                        Archive
                      </Button>
                    </>}
                  {selectedCorridor.status === 'Testing' && <>
                      <Button variant="contained" sx={{
                  bgcolor: '#0052CC',
                  '&:hover': {
                    bgcolor: '#003DA8'
                  }
                }} data-id="element-3472">
                        Test Connectivity
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#374151',
                  borderColor: '#D1D5DB'
                }} data-id="element-3473">
                        View Performance Data
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#374151',
                  borderColor: '#D1D5DB'
                }} data-id="element-3474">
                        Download Configuration
                      </Button>
                    </>}
                  {selectedCorridor.status === 'Setup' && <>
                      <Button variant="contained" sx={{
                  bgcolor: '#0052CC',
                  '&:hover': {
                    bgcolor: '#003DA8'
                  }
                }} data-id="element-3475">
                        Continue Setup
                      </Button>
                      <Button variant="contained" sx={{
                  bgcolor: '#0B7923',
                  '&:hover': {
                    bgcolor: '#07591F'
                  }
                }} data-id="element-3476">
                        Start Certification
                      </Button>
                      <Button variant="outlined" sx={{
                  color: '#AE2A19',
                  borderColor: '#AE2A19'
                }} data-id="element-3477">
                        Discard Configuration
                      </Button>
                    </>}
                </Box>
              </Box>}
          </Box>
        </Container>
      </Box>
    </Box>;
}